import { aludraApi } from 'api/axios'

const cotizacionByClient = '/mdl14/pointscard?CustomerId='

export const getPuntosGordosByClientService = async id => {
  return aludraApi.get(cotizacionByClient + id)
}
